import { Page } from 'layouts/Page';
import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { EUDRUser } from 'components/EUDRUser';
import { ROLES } from 'routes/constants';
import { Box, Typography } from '@mui/material';

export const EUDRUserPage: FC = () => {
	// const userinfo = useSelector(getUserInfo);
	const userinfo = {
		roles: [{ roleNameUI: ROLES.ADMIN }, { roleNameUI: ROLES.EUDR }],
	};

	const hasPermission = useMemo(
		() =>
			userinfo?.roles?.some(
				(role) => role.roleNameUI === ROLES.ADMIN || role.roleNameUI === ROLES.EUDR,
			),
		[userinfo?.roles],
	);

	return (
		<Page title="EUDR User – EAS Control Center">
			{hasPermission ? (
				<EUDRUser />
			) : (
				<Box sx={{ p: 2 }}>
					<Typography variant="h6">You do not have permission to view this page.</Typography>
				</Box>
			)}
		</Page>
	);
};
